import shortSlotRoll from './short-slot-roll.mp3';
import longSlotRoll from './long-slot-roll.mp3';
import kefkaLaugh from './bad-rolls/ff6-kefkalaugh.mp3';
import marioDie from './bad-rolls/mario-die.mp3';
import marioParty2Lose from './bad-rolls/marioparty2-lose.mp3';
import megaman7Warning from './bad-rolls/megaman7-warning.mp3';
import shaoKahn1 from './bad-rolls/laugh1.mp3';
import shaoKahn2 from './bad-rolls/laugh2.mp3';
import shaoKahn3 from './bad-rolls/laugh3.mp3';
import earthboundSpellGet from './good-rolls/earthbound-spellget.mp3';
import auronNoDifficult from './good-rolls/ffx-auronnodifficulty.mp3';
import yunaWeCanWin from './good-rolls/ffx-yunawecanwin.mp3';
import kirbyWin from './good-rolls/kirby-win.mp3';
import lttpItemFind from './good-rolls/lttp-itemfind.mp3';
import marioParty2Win from './good-rolls/marioparty2-win.mp3';
import megamanXItem from './good-rolls/megamanx-item.mp3';
import ootItem from './good-rolls/oot-item.mp3';
import peperMarioLevelUp from './good-rolls/pepermario-levelup.mp3';
import pokemonBWItemGet from './good-rolls/pokemonbw-itemget.mp3';
import zeldaSecret from './good-rolls/zelda1-secret.mp3';

export { shortSlotRoll, longSlotRoll };

export const goodRolls = [
  earthboundSpellGet,
  auronNoDifficult,
  yunaWeCanWin,
  kirbyWin,
  lttpItemFind,
  marioParty2Win,
  megamanXItem,
  ootItem,
  peperMarioLevelUp,
  pokemonBWItemGet,
  zeldaSecret,
];

export const cursedRolls = [shaoKahn1, shaoKahn2, shaoKahn3];
